import { CURRENCY } from '@common/constants'

export interface LocationState {
    countries: Country[]
    states: State[]
    validAddress: boolean
    correctedAddress: Address
    addressErrors: AddressError[]
    isLocationInfoLoaded: boolean
    locationInfo: LocationInfoState
    isCountriesLoaded: boolean
    isUserCountryAllowed: boolean
    isValidatingAddress: boolean
}

export interface State {
    name: string
    code: string
}

export interface Country {
    abbreviation: string
    name: string
    countryCode: string
    states?: State[]
    hasTaxId: boolean
    taxId: string
    taxIdRegex: string
    taxType: string
}

export interface Address {
    addressLine1: string
    addressLine2?: string
    city: string
    country: string
    phoneNumber: string
    postalCode: string
    state: string
}

// See api reference for /ecommapi/avs/validateaddress
// https://confluence.ops.expertcity.com/x/iD-ICg
export interface AddressDataType {
    address: Address
    email: string
    exportCompliance: boolean
    firstName: string
    lastName: string
    validateAddress: boolean
}

export interface ValidateAddressRequestUCS {
    firstName: string
    lastName: string
    addressLine1: string
    addressLine2?: string
    city: string
    state?: string
    country: string
    postalCode?: string
    phoneNumber: string
    email: string
}

export interface ValidateAddressResponseUCS {
    status?: ValidateAddressStatusUCS
    correctedAddress?: Address
    id?: string
    errors?: AddressError[]
}

export enum ValidateAddressStatusUCS {
    VALID = 'VALID',
    VALID_UPDATED = 'VALID_UPDATED',
    INVALID = 'INVALID',
    EXPORT_FAILED = 'EXPORT_FAILED',
}

export interface LocationInfoState {
    country: string
    currency: CURRENCY
    locale: string
    language: string
}

export interface LocationFormData {
    FirstName: string
    LastName: string
    Email: string
    Street1: string
    City: string
    ZipCode: string
    StateCode: string
    CountryCode: string
    ContactPhone: string
}

export interface AddressError {
    code: string
    message: string
    field: string
    friendlyMessage: string
}
